"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
function default_1({ isInputMode, onDialogBackOrClose, }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "surface-white", css: {
            position: 'sticky',
            top: 0,
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '50px',
            zIndex: 1,
        } }, { children: [(0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ sx: { position: 'absolute', left: '12px' }, onClick: onDialogBackOrClose }, { children: isInputMode ? (0, jsx_runtime_1.jsx)(svgs_1.HeaderBackSvg, {}) : (0, jsx_runtime_1.jsx)(svgs_1.HeaderCloseSvg, {}) })), !isInputMode && (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body2 gray-80" }, { children: t('배송지 관리') }))] })));
}
exports.default = default_1;
